import { useTranslation } from 'next-i18next';
import { cn } from '@/utils';
import type { CategoryTab } from '../avatarDecorate.logic';
const TAB_LABEL_KEY = {
  face: 'avatarDecorate.tab.face',
  skin: 'avatarDecorate.tab.skin',
  hair: 'avatarDecorate.tab.hair',
  clothes: 'avatarDecorate.tab.clothes',
  glasses: 'avatarDecorate.tab.glasses'
} as const satisfies Record<CategoryTab, string>;

// 악세사리(glasses) 포함 전 카테고리. 선생님(비학생) 계정도 동일하게 노출한다.
const TAB_ORDER: CategoryTab[] = ['skin', 'clothes', 'hair', 'face', 'glasses'];
export const AvatarCategoryTabs = ({
  activeTab,
  onSelect
}: {
  activeTab: CategoryTab;
  onSelect: (tab: CategoryTab) => void;
}) => {
  const {
    t
  } = useTranslation('common');
  const tabs = TAB_ORDER;
  return <div className="flex flex-row gap-3xs overflow-x-auto mobile-lg:flex-col mobile-lg:items-start mobile-lg:gap-xs mobile-lg:overflow-visible mobile-lg:pb-sm mobile-lg:pr-sm mobile-lg:pt-md" data-sentry-component="AvatarCategoryTabs" data-sentry-source-file="AvatarCategoryTabs.tsx">
      {tabs.map(tab => {
      const isActive = tab === activeTab;
      return <button key={tab} type="button" onClick={() => onSelect(tab)} className={cn('relative flex h-[32px] min-w-[72px] shrink-0 items-center justify-center whitespace-nowrap rounded-t-[6px] px-sm py-2xs text-body-lg-bold text-assistive transition-colors', 'mobile-lg:h-[36px] mobile-lg:w-[124px] mobile-lg:min-w-0 mobile-lg:flex-none mobile-lg:basis-auto mobile-lg:justify-start mobile-lg:gap-sm mobile-lg:rounded-none mobile-lg:px-0 mobile-lg:py-0 mobile-lg:text-body-md-semibold', isActive ?
      // Figma(Status=Selected 1259:59932): 선택 텍스트는 Violet500 #6758FF.
      // text-strong 은 primary.strong(Violet600 #5748F2)이라 시안보다 어둡고,
      // textColor 토큰에 Violet500 계열이 없어 hex 를 직접 쓴다.
      // (좌측 인디케이터 바의 bg-strong-default 는 이미 #6758FF 로 맞다)
      'font-bold text-[#6758FF]' :
      // Figma(Status=Hover 1259:59931): 호버는 배경 pill 만 bg/neutral 로 바뀌고
      // 텍스트 색은 text/neutral 그대로 유지된다. 텍스트 색 변경 없음.
      'text-assistive mobile-lg:text-neutral')}>
            <span className={cn('hidden h-[22px] w-[4px] shrink-0 bg-strong-default mobile-lg:block', !isActive && 'mobile-lg:invisible')} />
            <span className={cn('flex items-center justify-center mobile-lg:h-[30px] mobile-lg:flex-1 mobile-lg:justify-start mobile-lg:rounded-[4px] mobile-lg:py-xs mobile-lg:pl-xs mobile-lg:pr-sm',
        // text-strong-default 는 zus textColor 에 없는 클래스라 아무 효과가 없었다.
        // 선택 색은 위 버튼의 text-[#6758FF] 가 담당한다.
        !isActive && 'mobile-lg:hover:bg-neutral')}>
              {t(TAB_LABEL_KEY[tab])}
            </span>
            {isActive && <span className="absolute bottom-0 left-0 h-[2px] w-full bg-strong mobile-lg:hidden" />}
          </button>;
    })}
    </div>;
};